<kendo-dialog-titlebar>
    {{label}}
</kendo-dialog-titlebar>

<div fxLayout="column" fxLayoutGap="15px">

    <div>
        {{selectedText}}
    </div>

    <div fxLayoutAlign="center center" fxLayoutGap="15px">
        <button type="button" kendoButton (click)="close()" [primary]="true">
            <span>{{'global.close' | translate}}</span>
        </button>
    </div>
</div>